export const formatDate = (dateString, language = 'spanish', options = {}) => {
  if (!dateString) return language === 'english' ? 'Not available' : 'No disponible';
  
  try {
    const date = new Date(dateString);
    const locale = language === 'english' ? 'en-US' : 'es-ES';
    
    const defaultOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    
    return date.toLocaleDateString(locale, { ...defaultOptions, ...options });
  } catch (error) {
    return dateString;
  }
};

export const formatDateTime = (dateString, language = 'spanish') => {
  if (!dateString) return language === 'english' ? 'Not available' : 'No disponible';
  
  try {
    const date = new Date(dateString);
    const locale = language === 'english' ? 'en-US' : 'es-ES';
    
    return date.toLocaleString(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    return dateString;
  }
};

export const formatTime = (dateString, language = 'spanish') => {
  if (!dateString) return language === 'english' ? 'Not available' : 'No disponible';
  
  try {
    const date = new Date(dateString);
    const locale = language === 'english' ? 'en-US' : 'es-ES';
    
    return date.toLocaleTimeString(locale, {
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    return dateString;
  }
};

export const formatDateWithWeekday = (dateString, language = 'spanish') => {
  if (!dateString) return language === 'english' ? 'Not available' : 'No disponible';
  
  try {
    const date = new Date(dateString);
    const locale = language === 'english' ? 'en-US' : 'es-ES';
    
    return date.toLocaleDateString(locale, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch (error) {
    return dateString;
  }
};

export const formatDateShort = (dateString, language = 'spanish') => {
  if (!dateString) return language === 'english' ? 'Not available' : 'No disponible';
  
  try {
    const date = new Date(dateString);
    const locale = language === 'english' ? 'en-US' : 'es-ES';
    
    return date.toLocaleDateString(locale, {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  } catch (error) {
    return dateString;
  }
};